import { type Config, DEFAULT_CONFIG, loadConfig } from "@codeshare/config";

/**
 * What this deployment uses before your own settings: built-in defaults, the build environment
 * and /config.json. Shown as "the default" in Connection settings.
 */
export async function loadDeploymentConfig(): Promise<Config> {
  try {
    const { config } = await loadConfig({
      env: import.meta.env,
      fetch: (url, init) => fetch(url, { ...init, cache: "no-store" }),
      configUrl: `${import.meta.env.BASE_URL}config.json`,
      storage: null,
    });
    return config;
  } catch {
    return DEFAULT_CONFIG;
  }
}
